import { render, staticRenderFns } from "./returns-and-exchanges.vue?vue&type=template&id=89b4195e&"
import script from "./returns-and-exchanges.vue?vue&type=script&lang=js&"
export * from "./returns-and-exchanges.vue?vue&type=script&lang=js&"
import style0 from "./returns-and-exchanges.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports